import { Controller } from "@hotwired/stimulus"
import { template } from "lodash"

export default class extends Controller {
  static targets = ["select", "container", "template", "removeBtn", "undoBtn"]
  static classes = ["removedRow", "activeRow"]

  connect() {
    this.compiledTemplate = template(this.templateTarget.innerHTML)
    this.updateDropdownOptions()
  }

  isDepartmentActive(departmentId, excludeRow = null) {
    const deptRows = this.containerTarget.querySelectorAll(".department-row")
    for (let i = 0; i < deptRows.length; i++) {
      const row = deptRows[i]
      if (row === excludeRow) continue

      const idInput = row.querySelector('input[name*="[department_id]"]')
      const removeField = row.querySelector('input[name*="[remove]"]')

      if (idInput && idInput.value === departmentId &&
          (!removeField || removeField.value !== "true")) {
        return true
      }
    }
    return false
  }

  isDepartmentExists(departmentId, excludeRow = null) {
    const deptRows = this.containerTarget.querySelectorAll(".department-row")
    for (let i = 0; i < deptRows.length; i++) {
      const row = deptRows[i]
      if (row === excludeRow) continue

      const idInput = row.querySelector('input[name*="[department_id]"]')
      if (idInput && idInput.value === departmentId) {
        return row
      }
    }
    return false
  }

  updateDropdownOptions() {
    const options = this.selectTarget.querySelectorAll("option[value]")
    options.forEach(option => {
      if (option.value && this.isDepartmentExists(option.value)) {
        option.disabled = true
        option.textContent = option.dataset.name + " (już na liście)"
      } else if (option.value) {
        option.disabled = false
        option.textContent = option.dataset.name
      }
    })
  }

  addDepartment(_event) {
    const select = this.selectTarget
    if (!select.value) return

    const deptId = select.value
    const deptName = select.options[select.selectedIndex].dataset.name

    const existingRow = this.isDepartmentExists(deptId)
    if (existingRow) {
      const removeField = existingRow.querySelector('input[name*="[remove]"]')
      if (removeField && removeField.value === "true") {
        alert(this.data.get("departmentExistsUnpinnedMessage") || "Department is already on the list but unpinned. Please restore it instead of adding a new one.")
      } else {
        alert(this.data.get("departmentAlreadyAddedMessage") || "Department already added")
      }
      return
    }

    const index = Date.now()
    const html = this.compiledTemplate({ index, deptName, deptId })
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    select.value = ""
    this.updateDropdownOptions()
  }

  removeDepartment(event) {
    if (!confirm(this.data.get("confirmRemoveMessage"))) return

    const row = event.currentTarget.closest(".department-row")
    const removeField = row.querySelector('input[name*="[remove]"]')
    if (!removeField) return

    removeField.value = "true"
    row.classList.add(...this.removedRowClasses)
    row.classList.remove(...this.activeRowClasses)
    row.querySelectorAll('input:not([type="hidden"])').forEach(input => { input.disabled = true })
    row.querySelector('[data-bank-account-departments-target="removeBtn"]').classList.add("hidden")
    row.querySelector('[data-bank-account-departments-target="undoBtn"]').classList.remove("hidden")
    this.updateDropdownOptions()
  }

  undoDepartment(event) {
    const row = event.currentTarget.closest(".department-row")
    const currentDeptId = row.querySelector('input[name*="[department_id]"]').value

    if (this.isDepartmentActive(currentDeptId, row)) {
      alert(this.data.get("departmentAlreadyAddedMessage") || "Department already added")
      return
    }

    const removeField = row.querySelector('input[name*="[remove]"]')
    if (!removeField) return

    removeField.value = "false"
    row.classList.remove(...this.removedRowClasses)
    row.classList.add(...this.activeRowClasses)
    row.querySelectorAll('input:not([type="hidden"])').forEach(input => { input.disabled = false })
    row.querySelector('[data-bank-account-departments-target="removeBtn"]').classList.remove("hidden")
    row.querySelector('[data-bank-account-departments-target="undoBtn"]').classList.add("hidden")
    this.updateDropdownOptions()
  }
}
